module.exports = __webpack_public_path__ + "img/stuck1.097a21b6.jpg";